<template>
    <div id="shokolad">
        <section class="welcome">
            <div class="bg"><span></span></div>
            <div class="start">
                <h1><span>Мягкий молочный шоколад&nbsp;&mdash;<br> <b>эксклюзивное лакомство из&nbsp;цельного молока и&nbsp;какао</b></span></h1>
                <div class="text">Натуральный состав, нежная текстура, мягкий вкус и&nbsp;полезные свойства, сохраненные в&nbsp;продукте благодаря особым 
                технологиям производства,&nbsp;&mdash; все это мягкий молочный шоколад от&nbsp;&laquo;Коровки из&nbsp;Кореновки&raquo;. 
                Эксклюзивное лакомство из&nbsp;цельного молока и&nbsp;какао, которое производится на&nbsp;Кубани без добавления растительных жиров.</div>
                <h3 onclick="location.href='https://chokoboom.com';">Не&nbsp;содержит растительных жиров&nbsp;&mdash; натуральная альтернатива шоколадной пасте</h3>
                <div class="block">Мягкий молочный шоколад&nbsp;&mdash; это натуральная альтернатива шоколадной пасте. С&nbsp;блинчиками или оладьями, 
                в&nbsp;качестве начинки для выпечки и&nbsp;десертов, даже просто с&nbsp;кусочком свежего хлеба&nbsp;&mdash; как есть мягкий молочный шоколад 
                решать только Вам!
                </div>
            <div class="item-content">    
                <p>Адрес веб-сайта:<br>
                    <a href="https://chokoboom.com">https://chokoboom.com</a>
                </p>
            </div>
            <div class="lenta">

                <news></news>

                <!--<div class="lenta-logo"></div>-->
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Chocolate"
    }
</script>